module.exports = __webpack_public_path__ + "static/media/giraffes2.1aef0350.png";